import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import android from "./Images/andr.png";
import react from "./Images/react.png";
import {
  faRocket,
  faUsers,
  faMobileAlt,
  faDesktop,
  faGlobe,
  faSmile
} from "@fortawesome/free-solid-svg-icons";
import { useInView } from "react-intersection-observer"; // Import useInView
import IndustriesWeServe from "./IndustriesWeServe";
import TopComp from "./Topcomp";

// Counter Component with Viewport Trigger
const Counter = ({ targetNumber, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: false }); // triggerOnce false to allow re-triggering on re-entering the viewport

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // Total animation duration in ms
      const stepTime = Math.max(Math.floor(duration / targetNumber), 10); // Time per step

      const counterInterval = setInterval(() => {
        start += 1;
        setCount(start);
        if (start >= targetNumber) {
          clearInterval(counterInterval);
        }
      }, stepTime);

      // Cleanup on component unmount or reentering the viewport
      return () => clearInterval(counterInterval);
    }
  }, [inView, targetNumber]); // Re-run effect when inView or targetNumber changes

  return (
    <div ref={ref} className="text-left">
      <h2 className="mt-4 text-2xl font-bold text-gray-900">
        {count}
        {suffix}
      </h2>
    </div>
  );
};

function AndroidAppDevelopment() {
  return (
    <div className="flex flex-col tracking-widest gap-16">
      {/* Header Section */}
      <div>
        <TopComp />
      </div>

      {/* Main Content */}
      <div className="p-6 w-full max-w-[120em] mx-auto flex flex-col lg:flex-row ">
        <div className="container  lg:mx-11 lg:w-1/2 w-full">
          <div className="flex lg:justify-start justify-center">
            <div className="w-full lg:w-2/3">
              <div className="common-heading">
                <h2 className="text-3xl lg:text-5xl lg:text-left font-bold">
                  <span className="gradient-text">Android Application</span>{" "}
                  Development
                </h2>
              </div>
            </div>
          </div>
          <div className="mt-3 lg:px-0  ">
            <div className="text-justify lg:text-left text text-[#736a8e]">
              <p className="text-gray-600 mt-6 leading-relaxed">
                {" "}
                At <b>Versai Tech Solutions</b>, we specialize in Android app
                development. Our team creates high-quality apps designed to be
                user-friendly and responsive, ensuring a seamless experience for
                every user. We understand that a well-designed app can make a
                big difference in user satisfaction and engagement.{" "}
              </p>{" "}
              <p className="text-gray-600 mt-4 leading-relaxed">
                {" "}
                Many apps receive poor reviews because they are difficult to
                navigate or have other issues. As smartphone usage continues to
                rise, Android apps play a crucial role in our daily routines,
                making it more important than ever to provide reliable and
                efficient solutions that meet user needs.{" "}
              </p>
            </div>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="mt-8 grid justify-start grid-cols-2 overflow-hidden sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="bg-blue-100 p-6  rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faRocket}
              className="text-4xl  text-blue-500"
            />
            <Counter targetNumber={1} suffix="+"  />
            <p className="text-gray-600">Years Experience</p>
          </div>
          <div className="bg-orange-100 p-6 rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faUsers}
              className="text-4xl text-orange-500"
            />
            <Counter targetNumber={20} suffix="+" />
            <p className="text-gray-600">Talented Squad</p>
          </div>
          <div className="bg-purple-100 p-6 rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faMobileAlt}
              className="text-4xl text-purple-500"
            />
            <Counter targetNumber={10} suffix="+" />
            <p className="text-gray-600"> Apps Developed</p>
          </div>
          <div className="bg-blue-100 p-6 rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faDesktop}
              className="text-4xl text-blue-500"
            />
            <Counter targetNumber={50} suffix="+" />
            <p className="text-gray-600">Projects Delivered</p>
          </div>
          <div className="bg-yellow-100 p-6 rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faGlobe}
              className="text-4xl text-yellow-500"
            />
            <Counter targetNumber={5} suffix="+" />
            <p className="text-gray-600">Countries Served</p>
          </div>
          <div className="bg-blue-100 p-6 rounded-lg shadow-md">
            <FontAwesomeIcon
              icon={faSmile}
              className="text-4xl text-blue-500"
            />
            <Counter targetNumber={100} suffix="%" />
            <p className="text-gray-600">Client Satisfaction</p>
          </div>
        </div>
      </div>
    
      <div className="text-center  max-w-[120em] mx-auto bg-white text-gray-800">
        {/* Holo Text for "APP DEVELOPMENT" */}
        <h1
          className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl  font-extrabold text-transparent stroke-1"
          style={{ WebkitTextStroke: "1px #e5e7eb" }}
        >
         ANDROID APP DEVELOPMENT
        </h1>

        {/* Service Section Title */}
        <h2 className="gradient-textt text-3xl mx-2 font-bold mt-4">
          Our Services
        </h2>
        <p className="text-lg text-gray-500 mt-2 mx-2">
          Mobile apps which can work on all the platforms with functionality to
          meet the user's expectation without a trace of glitch.
        </p>
        <div className="mt-12 px-6 text-left xl:mx-32 grid md:grid-rows-1 lg:grid-cols-2  grid-cols-1 gap-8 justify-center">
          {/* Android App Development */}
          <div className="bg-white shadow-lg rounded-lg p-4 max-w-full md:max-w-xl lg:max-w-lg mx-auto border-4 border-gray-200 transition-transform transform hover:scale-105">
            <div className="flex items-center mb-4">
              <img src={android} alt="Android logo" className="w-10 h-10" />
              <h3 className="text-xl font-bold text-gray-900 ml-4">
                Android Application Development
              </h3>
            </div>
            <p className="text-gray-600 text-justify lg:text-left">
              We create android apps that are faultless and exactly what you
              need for your business. We want to make sure that the app
              resonates with the intended audience and accomplishes its stated
              goal. We go to great lengths to ensure that the final product is
              of the highest quality by conducting extensive research and
              acquiring the necessary resources.
            </p>
          </div>

          {/* React Native App Development */}
          <div className="bg-white shadow-lg rounded-lg p-4 max-w-full md:max-w-xl lg:max-w-lg mx-auto border-4 border-gray-200 transition-transform transform hover:scale-105">
            <div className="flex items-center mb-4">
              <img src={react} alt="React logo" className="w-10 h-10" />
              <h3 className="text-xl font-bold text-gray-900 ml-4">
                React Native App Development
              </h3>
            </div>
            <p className="text-gray-600 text-justify lg:text-left">
              It is now common practice to create user interfaces with React
              Native, a framework built on top of the JavaScript library.
              Single-page and android app development benefit greatly from it. It
              is our job as an IT service provider to ensure that our clients
              get the most up-to-date technologies available. As a result, our
              clients can be assured of the best possible outcomes.
            </p>
          </div>

        
        </div>
      </div>

      <IndustriesWeServe />
    </div>
  );
}
export default AndroidAppDevelopment;
